import React, { useEffect, useState } from 'react'
import { FieldErrors, useForm } from 'react-hook-form'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useLocation } from 'react-router-dom'

import Button from 'components/Button'
import UserInfoInput from 'components/UserInfoInput'
import ButtonIcon from 'components/ButtonIcon'
import { toast } from 'App'

import { checkBadWords } from 'utils'
import loginStore from 'store/login'
import { IUser } from 'models'

import styles from './styles.module.scss'


const NicknameSchema = yup.object().shape({
  nickname: yup
    .string()
    .required('This field is required')
    .min(2, 'Nickname should be longer than 2 letters')
    .test('whitespace', 'You are not allowed to use whitespace', (value, context) => {
      const str = value as string
      return !str.match(/^$|\s+/);
    })
    .test('symbol@', 'You are not allowed to use symbol "@"', (value, context) => {
      const str = value as string
      return !str.match(/@/);
    })
    .test('badWords', 'You are not allowed to use prohibited words', (value, context) => {
      return !checkBadWords(value)
    })
    .test('nickname', 'Nickname already exists', (value, context) => {
      return loginStore.checkNickName(value)
    })
})

interface INicknameFormProps {
  nickname: string;
}

interface IProps {
  currentUser?: boolean
}

//Resize
const UserInfoNickname: React.FC<IProps> = observer(() => {
  const { profile, loading } = useStore()
  const [change, setChange] = useState(false)
  const { selectedUser } = profile
  const location = useLocation()
  const { register, handleSubmit, formState: { errors }, clearErrors } = useForm<INicknameFormProps>({
    resolver: yupResolver(NicknameSchema)
  })

  const onSubmit = async (data: INicknameFormProps) => {
    try {
      loading.setLoading(true)
      await profile.changeNickname(data.nickname)
      const updatedUser: IUser = { ...selectedUser, NickName: data.nickname, AbleToChangeNickname: false }
      profile.setViewedUser(updatedUser)
      profile.setSelectedUser(updatedUser)
      profile.setSessionProfileData(updatedUser)
      setChange(false)
      const state = { ...location.state }

      const newUrl = location.pathname === `/user/info/${selectedUser.NickName}` ? `/user/info/${data.nickname}` : `/user/${data.nickname}`
      window.history.replaceState(state, document.title, newUrl)
      loading.setLoading(false)
      toast({
        type: 'success',
        message: 'Nickname successfully changed'
      })
    } catch (e) {
      toast({
        type: 'error',
        message: 'Nickname not changed'
      })
      console.log('e', e)
      loading.setLoading(false)
    }
  }

  const onError = (err: FieldErrors) => {
    // if (err.nickname?.message) {
    //   toast({
    //     type: 'warning',
    //     message: err.FirstName.message
    //   })
    // }
  }

  return (
    <form
      className={cn(styles.cartBody)}
      onSubmit={handleSubmit(onSubmit, onError)}
    >
      <div className={styles.titleBlock}>
        <div className={styles.title}>Change nickname</div>
        <ButtonIcon
          style={{ pointerEvents: change ? 'none' : 'auto' }}
          icon={'edit'}
          onClick={() => setChange(true)}
        />
      </div>
      {selectedUser.NickName || change ?
        <UserInfoInput
          placeholder={'Nickname'}
          title={'Nickname'}
          edit={change}
          value={selectedUser.NickName}
          name={'nickname'}
          register={register}
          clearErrors={clearErrors}
          error={errors.nickname?.message}
          styleErrorIcon={{ padding: 0, width: '16px', height: '16px' }}
        /> : null}

      <div className={styles.warningMessage}>*You can change your nickname only once</div>

      {change ? (
        <div className={styles.saveBlock}>
          <div className={styles.cancelButton} onClick={() => setChange(false)}>
            Cancel
          </div>
          <Button
            type={'submit'}
            style={{
              background: 'linear-gradient(#2E2B63, #2E2B63)',
              boxShadow: '0px 7px 25px rgba(0, 0, 0, 0.0563538)',
              borderRadius: 11,
              width: '92px',
              height: '40px'
            }}
            styleText={{ color: '#ffffff' }}
            btnStyle="classic"
            text="Save"
          />
        </div>
      ) : null}
    </form>
  )
})

export default UserInfoNickname
